import { DEFAULT_POLL_DELAY_TIME_MS, POLL_INTERVAL_MS } from 'constants/defaults'
import { useEffect } from 'react'
import { fetchMarkets, fetchTokenList } from 'state/exchange/actions'

import { useAppDispatch, useAppSelector, useFetchAction } from 'state/hooks'
import { fetchOraclePrices } from 'state/prices/actions'
import sdk from 'state/sdk'
import { setMarketName } from './actions'
import { selectMarketName, selectNetwork, selectWallet } from './selectors'
import { updatePrices } from 'state/prices/reducer'
import { fetchBalance } from 'state/wallet/actions'

export function useFetchAppData(ready: boolean, marketName: string = '') {
	const dispatch = useAppDispatch()
	const wallet = useAppSelector(selectWallet)
	const network = useAppSelector(selectNetwork)
	const curMarketName = useAppSelector(selectMarketName)

	useFetchAction(()=>setMarketName(marketName), {
		dependencies: [network, curMarketName],
	})

	useFetchAction(fetchTokenList, { 
		dependencies: [network, curMarketName],
		disabled: curMarketName === undefined,
	})

	useFetchAction(fetchMarkets, { 
		dependencies: [network, curMarketName],
		disabled: curMarketName === undefined,
	})

	useFetchAction(fetchOraclePrices, { 
		dependencies: [],
		disabled: curMarketName === undefined,
	})

	useFetchAction(fetchBalance, { 
		dependencies: [network, curMarketName, wallet],
		disabled: curMarketName === undefined || network === undefined || wallet === null,
	})

	useEffect(() => {
		if (ready && curMarketName !== undefined) {
			setTimeout(()=>sdk.prices.startPriceUpdates(POLL_INTERVAL_MS), DEFAULT_POLL_DELAY_TIME_MS)
		}
	}, [ready, curMarketName, network])

	useEffect(() => {
		sdk.prices.onPricesUpdated(({ prices }) => {
			dispatch(updatePrices(prices))
		})

		return () => {
			sdk.prices.removePricesListeners()
		}
	}, [dispatch])
}
